import { makeStyles } from "@material-ui/core";

export const unauthorizedRouteStyle = makeStyles((theme) => ({
    wrapper: {
        padding: '50px',
        textAlign: 'center'
    }
}));